import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LargeurStation } from 'src/app/domain/MPCE/largeur-station';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';

@Component({
    selector: 'app-mpce-mgce-measure-box',
    templateUrl: './mpce-mgce-measure-box.component.html',
    styleUrls: ['./mpce-mgce-measure-box.component.scss']
})
export class MPCEMGCEMeasureBoxComponent implements OnInit {
    EInterventionType = EInterventionType;
    public DMAX = 20; // m
    ValidLpBMax = new UntypedFormControl(0, [Validators.max(this.DMAX)]);
    ValidLmMax = new UntypedFormControl(0, [Validators.max(this.DMAX)]);
    newMesure: LargeurStation;
    interventionType: EInterventionType;
    isForTransect: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<MPCEMGCEMeasureBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.newMesure = data.mesure;
        this.interventionType = data.type;
        this.isForTransect = data.isForTransect;
    }

    ngOnInit(): void {
        if (this.interventionType === EInterventionType.MGCE) {
            this.ValidLmMax.clearValidators();
            this.ValidLpBMax.clearValidators();
        }
        this.ValidLpBMax.markAsTouched();
        if (this.interventionType !== EInterventionType.IBMR && !this.isForTransect)
            this.ValidLmMax.markAsTouched();
        if (this.interventionType === EInterventionType.IBMR)
            this.ValidLpBMax.clearValidators()
    }

    getLpBLabel() {
        return this.isForTransect ? 'Longueur' : 'LpB';
    }

    CanAddNewMeasure() {
        if (this.interventionType === EInterventionType.IBMR && !this.isForTransect)
            return this.newMesure.LpB;
        return this.newMesure.Lm && this.newMesure.LpB;
        // && this.ValidLmMax.valid && this.ValidLpBMax.valid;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.newMesure);
    }
}
